export class ArbetsorderPeriodsattPeriodTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        periodsattPeriod: "Periodsätt arbetsorder"
    };
}
